<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                :pages="[
                    {
                        name: $t('messages.attendance_calendar'),
                        href: null,
                    },
                ]"
            />
        </template>

        <div>
            <NavLinks :links="meta.navLinks.schoolYears" />
        </div>

        <EmptyState picture v-if="!calendar" />
        <div v-else class="mt-5">
            <div class="grid-cols-2 md:grid-cols-3 md:gap-6">
                <div class="inline-block mr-5" v-for="month in calendar" :key="month.month_name">
                    <div>
                        {{ month.month_name }}
                    </div>
                    <div>
                        <table>
                            <tbody>
                                <tr v-for="week in month.data">
                                    <td
                                        v-for="weekday in week"
                                        :key="weekday.title"
                                        class="w-6 h-6 border-2 border-white"
                                        :class="weekday.class"
                                        :title="weekday.title"
                                    >
                                        <span class="text-white">{{ weekday.percent }}</span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

            <div class="mt-5 flex">
                <div class="flex mr-3">
                    <div class="w-6 h-6 border-2 border-white bg-teal-600 mr-1"></div>
                    {{ $tc('messages.holidays', 1) }}
                </div>
            </div>
        </div>

        <form action="" @submit.prevent="filter">
            <div>
                <div class="mt-1">
                    <FormLabel :value="$tc('messages.groups', 2)" for="group_ids" />
                    <SlideOverCheckboxInput v-model="form.group_ids" :options="options.groups" />
                    <FormError :value="form.errors.group_ids" class="mt-2" />
                </div>
            </div>
            <div class="flex justify-end">
                <SubmitFormButton :button-text="$t('messages.filter')" :processing="form.processing" is-filter />
            </div>
        </form>
    </PanelPage>
</template>

<script>
import Layout from '@/Shared/Layout.vue';
import PanelPage from '@/Shared/PanelPage.vue';
import NavLinks from '@/components/NavLinks.vue';
import SubmitFormButton from '@/Pages/Teacher/Activities/Subactivities/SubmitFormButton.vue';
import EmptyState from '@/components/EmptyState.vue';
import FormError from '@/components/Forms/FormError.vue';
import SlideOverCheckboxInput from '@/components/Forms/SlideOverCheckboxInput.vue';
import FormLabel from '@/components/Forms/FormLabel.vue';

export default {
    components: {
        FormLabel,
        SlideOverCheckboxInput,
        FormError,
        EmptyState,
        SubmitFormButton,
        NavLinks,
        PanelPage,
    },
    layout: Layout,
    name: 'Show',
    props: ['meta', 'options', 'filters', 'calendar'],
    data() {
        return {
            form: this.$inertia.form({
                group_ids: this.filters.group_ids,
            }),
        };
    },
    methods: {
        filter() {
            this.form.get(this.meta.links.index);
        },
    },
};
</script>
